export const MERKENHERZ_UPDATE_EVENT = "sbe.artikel-merken-herz.update";

export function sendMerkenherzUpdateEvent(target, artikelnummer, state) {
    const stateUpdateEvent = new CustomEvent(MERKENHERZ_UPDATE_EVENT, {
        detail: {
            target: target, artikelnummer: artikelnummer, state: state,
        }
    });
    document.dispatchEvent(stateUpdateEvent);
}
